import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError, config } from 'rxjs';
import { HttpServices } from '../../../shared/services/http-service.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { map, catchError } from 'rxjs/operators';
import { FloatingCranesRequestDTO } from '../models/FloatingCranesRequestDTO.model';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class FloatingCranesRequestService {

  constructor(private http: HttpServices, private httpClient: HttpClient) {
  }

  CreateFloatingCranesRequest(floatingCranesRequestDTO: FloatingCranesRequestDTO) {
    return this.http.post('FloatingCranesRequests/CreateFloatingCranesRequest', floatingCranesRequestDTO);
  }

  GetNumberOfDaysToSelectRequestExecutingDate() {
    return this.http.get('FloatingCranesRequests/GetNumberOfDaysToSelectFloatingCranesRequestExecutingDate');
  }

  GetFloatingCranesRequest(id) {
    return this.http.get('FloatingCranesRequests/GetFloatingCranesRequest/' + id);
  }

  public upload(formData) {
    return this.httpClient.post<any>('http://localhost:16586/api/FloatingCranesRequests/Upload', formData, {
      reportProgress: true,
      observe: 'events'
    }
    );
  }
}